<template>
  <div class="rp-page" dir="rtl">

    <v-dialog v-model="showVitalSignsDialog" max-width="1200" width="95%" persistent>
      <follow-up-patient-step4-component v-if="showVitalSignsDialog" :patientId="patientId"
        :patientAge="DataPatientById.yearOfAge" @reloadApiFun="reloadApiFun(2)"
        @goToNextDialog="goToNextDialog(3)"></follow-up-patient-step4-component>
    </v-dialog>
    <v-dialog v-model="showAccompanyingSymptomsDialog" max-width="1200" width="95%" persistent>
      <follow-up-patient-step5-component v-if="showAccompanyingSymptomsDialog" :patientId="patientId"
        :missionType="missionType" @reloadApiFun="reloadApiFun(3)" @goToNextDialog="goToNextDialog(4)"
        :flagShowForm="flagShowForm"></follow-up-patient-step5-component>
    </v-dialog>
    <v-dialog v-model="showMedicalHistoryDialog" max-width="1200" width="95%" persistent>
      <follow-up-patient-step6-component v-if="showMedicalHistoryDialog" :patientId="patientId"
        :missionType="missionType" @reloadApiFun="reloadApiFun(4)" @goToNextDialog="goToNextDialog(5)"
        :flagShowForm="flagShowForm"></follow-up-patient-step6-component>
    </v-dialog>
    <v-dialog v-model="showDrugHistoryDialog" max-width="1200" width="95%" persistent>
      <follow-up-patient-step7-component v-if="showDrugHistoryDialog" :patientId="patientId" :missionType="missionType"
        @reloadApiFun="reloadApiFun(5)" @goToNextDialog="goToNextDialog(6)"
        :flagShowForm="flagShowForm"></follow-up-patient-step7-component>
    </v-dialog>
    <v-dialog v-model="showAllergyHistoryDialog" max-width="1200" width="95%" persistent>
      <follow-up-patient-step8-component v-if="showAllergyHistoryDialog" :patientId="patientId"
        :missionType="missionType" @reloadApiFun="reloadApiFun(6)"
        @goToNextDialog="goToNextDialog(7)"></follow-up-patient-step8-component>
    </v-dialog>
    <v-dialog v-model="showMedicalExaminationDialog" max-width="1200" width="95%" persistent>
      <follow-up-patient-step9-component v-if="showMedicalExaminationDialog" :patientId="patientId"
        :missionType="missionType" @reloadApiFun="reloadApiFun(7)" @goToNextDialog="goToNextDialog(8)"
        :flagShowForm="flagShowForm"></follow-up-patient-step9-component>
    </v-dialog>
    <v-dialog v-model="showBodyExaminationDialog" max-width="1200" width="95%" persistent>
      <follow-up-patient-step10-component v-if="showBodyExaminationDialog" :patientId="patientId"
        :missionType="missionType" @reloadApiFun="reloadApiFun(8)"
        @goToNextDialog="goToNextDialog(9)"></follow-up-patient-step10-component>
    </v-dialog>
    <v-dialog v-model="showGeneralActionsDialog" max-width="1200" width="95%" persistent>
      <follow-up-patient-step11-component v-if="showGeneralActionsDialog" :patientId="patientId"
        @reloadApiFun="reloadApiFun(9)" @goToNextDialog="goToNextDialog(10)" :flagShowForm="flagShowForm"
        :diagnosis="DetailByFollowup?.diagnosis"></follow-up-patient-step11-component>
    </v-dialog>
    <v-dialog v-model="showTechnicianDrugsDialog" max-width="1200" width="95%" persistent>
      <follow-up-patient-step12-component v-if="showTechnicianDrugsDialog" :patientId="patientId"
        @reloadApiFun="reloadApiFun(10)" @goToNextDialog="goToNextDialog(11)"></follow-up-patient-step12-component>
    </v-dialog>
    <v-dialog v-model="showMedicalItemsDialog" max-width="1200" width="95%" persistent>
      <follow-up-patient-step13-component v-if="showMedicalItemsDialog" :patientId="patientId"
        @reloadApiFun="reloadApiFun(11)" @goToNextDialog="goToNextDialog(12)"></follow-up-patient-step13-component>
    </v-dialog>
    <v-dialog v-model="showPatientResultDialog" max-width="1200" width="95%" persistent>
      <follow-up-patient-step14-component v-if="showPatientResultDialog" :patientId="patientId"
        :missionPhoneId="missionPhoneId" @reloadApiFun="reloadApiFun(12)"
        @goToNextDialog="goToNextDialog(13)"></follow-up-patient-step14-component>
    </v-dialog>


    <div class="rp-panel el-0"></div>
    <!-- <div class="rp-text el-3">تاریخ ماموریت:</div>
    <div class="rp-text el-4">{{ data.MissionDatePersian }}</div> -->
    <!-- <div class="rp-text el-7">فرم ({{ flagShowForm }}) - {{ DetailByFollowup?.diagnosis ?? '' }}</div> -->
    <!-- <div class="rp-text el-8">کد :</div>
    <div class="rp-text el-9">{{ data.PhoneCode }}</div> -->
    <div class="rp-panel el-12"></div>
    <div class="rp-panel el-13"></div>
    <div class="rp-text btnClick-14" @click="$root.$refs.FollowUpPatient.changeTab(1)"></div>
    <div class="rp-text el-14">
      <v-icon class="ml-2" color="#0A6ADA" size="24">mdi mdi-text-box-edit-outline</v-icon>
      اطلاعات اولیه و مشخصات عمومی
    </div>
    <div class="rp-panel el-15"></div>
    <div class="rp-text el-16">{{ DataPatientById?.firstName ?? '' }} {{ DataPatientById?.lastName ?? '' }}</div>
    <div class="rp-text el-17">نام و نام خانوادگی:</div>
    <div class="rp-panel el-18"></div>
    <div class="rp-text el-19">
      {{ DataPatientById.yearOfAge ? DataPatientById.yearOfAge + ' سال ' : '' }}
      {{ DataPatientById.monthOfAge ? DataPatientById.monthOfAge + ' ماه ' : '' }}
      {{ DataPatientById.ageTotalDays ? DataPatientById.ageTotalDays + ' روز ' : '' }}
    </div>
    <div class="rp-text el-20">سن:</div>
    <div class="rp-panel el-21"></div>
    <div class="rp-text el-22">{{ getTitleById(nationalityList, DataPatientById?.nationality) }}</div>
    <div class="rp-text el-23">ملیت:</div>
    <div class="rp-panel el-24"></div>
    <div class="rp-text el-25">جنس:</div>
    <div class="rp-text el-26">{{ getTitleById(genderFollowUpItems, DataPatientById?.gender) }}</div>
    <div class="rp-panel el-27"></div>
    <div class="rp-text el-28">{{ DataPatientById.nationalCode ?? '' }}</div>
    <div class="rp-text el-29">کد ملی:</div>

    <div class="rp-text el-37">تشخیص اولیه</div>
    <div class="rp-text el-38">شکایت اصلی بیمار</div>
    <div class="rp-text el-41">{{ DataPatientById?.chiefComplaintText ?? '' }}</div>
    <div class="rp-text el-42">{{ DetailByFollowup?.diagnosis ?? '' }}</div>
    <div class="rp-text el-45">کارشناس عملیات</div>

    <template v-if="flagShowForm == 1">
      <div class="rp-panel el-93"></div>
      <div class="rp-text el-94">اطلاعات تکمیلی</div>
      <div class="rp-text el-95">نوع تردد</div>
      <div class="rp-text el-96">{{ DetailByFollowup?.patientTraumaDetail?.transitType }}</div>
      <div class="rp-text el-97">نوع وسیله نقلیه</div>
      <div class="rp-text el-98">{{ DetailByFollowup?.patientTraumaDetail?.vehicleType }}</div>
      <div class="rp-text el-99">وضعیت مصدوم</div>
      <div class="rp-text el-100">{{ DetailByFollowup?.patientTraumaDetail?.patientState }}</div>
      <div class="rp-text el-101">رهاسازی</div>
      <div class="rp-text el-102">
        {{ DetailByFollowup?.patientTraumaDetail?.releaseAfter ? 'در حضور تکنسین' : 'قبل از رسیدن تکنسین' }}
      </div>
    </template>
    <template v-if="flagShowForm == 2">
      <div class="rp-panel el-93"></div>
      <div class="rp-text el-94">نوع حادثه</div>
      <div class="rp-text el-254">
        {{ DetailByFollowup?.diagnosis ?? '' }}
        {{ DetailByFollowup?.diagnosisDetail ? '(' + DetailByFollowup?.diagnosisDetail + ')' : '' }}
      </div>
    </template>
    <template v-if="flagShowForm >= 3">
      <div class="rp-panel el-93"></div>
      <div class="rp-text el-94">تشخیص اولیه</div>
      <div class="rp-text el-254">
        {{ DetailByFollowup?.diagnosis ?? '' }}
        {{ DetailByFollowup?.diagnosisDetail ? '(' + DetailByFollowup?.diagnosisDetail + ')' : '' }}
      </div>
    </template>

    <div class="rp-panel el-86"></div>
    <div class="rp-text el-87">ارزیابی اولیه</div>

    <div class="rp-text el-88" :class="{ 'el-88a': flagShowForm > 2 }">
      سطح هوشیاری: {{ InitialAssessmentById?.consciousnessLevel?.title }}
    </div>
    <div class="rp-text el-89" :class="{ 'el-89a': flagShowForm > 2 }">
      راه هوایی: {{ InitialAssessmentById?.airway?.title }}
    </div>
    <div class="rp-text el-90" :class="{ 'el-90a': flagShowForm > 2 }">
      تنفس: {{ InitialAssessmentById?.respiration?.title }}
    </div>
    <div class="rp-text el-91" :class="{ 'el-91a': flagShowForm > 2 }">
      گردش خون: {{ InitialAssessmentById?.bloodCirculation?.title }}
    </div>
    <div v-if="flagShowForm <= 2" class="rp-text el-92">
      قابلیت حرکت: {{ extractTrueKeys(DetailByFollowup?.patientMovementAbility)?.all ?? '' }}
    </div>

    <template v-if="DataPatientById != null">

      <div class="rp-panel el-103"></div>
      <div class="rp-text btnClick-104" @click="showVitalSignsDialog = true"></div>
      <div class="rp-text el-104">
        <v-icon class="ml-2" color="#0A6ADA" size="24">mdi mdi-text-box-edit-outline</v-icon>
        علائم حیاتی <span class="red--text">*</span>
      </div>
      <div class="rp-text el-105">زمان کنترل</div>
      <div class="rp-text el-106">BS</div>
      <div class="rp-text el-107">SPO2</div>
      <div class="rp-text el-108">BP</div>
      <div class="rp-text el-109">RR</div>
      <div class="rp-text el-110">PR</div>
      <div class="rp-text el-111">Temp</div>
      <div class="rp-text el-112">E4</div>
      <div class="rp-text el-113">V5</div>
      <div class="rp-text el-114">M6</div>
      <div class="rp-text el-115">T15</div>
      <div class="rp-text el-116">Gap Score</div>
      <div class="rp-text el-117">GCS</div>
      <div class="rp-text el-118">{{ dateTimeChange(vitalSigns[0]?.observationDate) }}</div>
      <div class="rp-text el-119">{{ dateTimeChange(vitalSigns[1]?.observationDate) }}</div>
      <div class="rp-text el-120">{{ dateTimeChange(vitalSigns[2]?.observationDate) }}</div>
      <div class="rp-text el-121">{{ dateTimeChange(vitalSigns[3]?.observationDate) }}</div>
      <div class="rp-text el-122">{{ vitalSigns[0]?.bloodSugar ?? 0 }}</div>
      <div class="rp-text el-123">{{ vitalSigns[1]?.bloodSugar ?? 0 }}</div>
      <div class="rp-text el-124">{{ vitalSigns[2]?.bloodSugar ?? 0 }}</div>
      <div class="rp-text el-125">{{ vitalSigns[3]?.bloodSugar ?? 0 }}</div>
      <div class="rp-text el-126">{{ vitalSigns[0]?.spO2 ?? 0 }}</div>
      <div class="rp-text el-127">{{ vitalSigns[1]?.spO2 ?? 0 }}</div>
      <div class="rp-text el-128">{{ vitalSigns[2]?.spO2 ?? 0 }}</div>
      <div class="rp-text el-129">{{ vitalSigns[3]?.spO2 ?? 0 }}</div>
      <div class="rp-text el-130">{{ vitalSigns[0]?.systolicBloodPressure ?? 0 }}/{{
        vitalSigns[0]?.diastolicBloodPressure ?? 0 }}</div>
      <div class="rp-text el-131">{{ vitalSigns[1]?.systolicBloodPressure ?? 0 }}/{{
        vitalSigns[1]?.diastolicBloodPressure ?? 0 }}</div>
      <div class="rp-text el-132">{{ vitalSigns[2]?.systolicBloodPressure ?? 0 }}/{{
        vitalSigns[2]?.diastolicBloodPressure ?? 0 }}</div>
      <div class="rp-text el-133">{{ vitalSigns[3]?.systolicBloodPressure ?? 0 }}/{{
        vitalSigns[3]?.diastolicBloodPressure ?? 0 }}</div>
      <div class="rp-text el-134">{{ vitalSigns[0]?.respiratoryRate ?? 0 }}</div>
      <div class="rp-text el-135">{{ vitalSigns[1]?.respiratoryRate ?? 0 }}</div>
      <div class="rp-text el-136">{{ vitalSigns[2]?.respiratoryRate ?? 0 }}</div>
      <div class="rp-text el-137">{{ vitalSigns[3]?.respiratoryRate ?? 0 }}</div>
      <div class="rp-text el-138">{{ vitalSigns[0]?.pulseRate ?? 0 }}</div>
      <div class="rp-text el-139">{{ vitalSigns[1]?.pulseRate ?? 0 }}</div>
      <div class="rp-text el-140">{{ vitalSigns[2]?.pulseRate ?? 0 }}</div>
      <div class="rp-text el-141">{{ vitalSigns[3]?.pulseRate ?? 0 }}</div>
      <div class="rp-text el-142">{{ vitalSigns[0]?.temperature ?? 0 }}</div>
      <div class="rp-text el-143">{{ vitalSigns[1]?.temperature ?? 0 }}</div>
      <div class="rp-text el-144">{{ vitalSigns[2]?.temperature ?? 0 }}</div>
      <div class="rp-text el-145">{{ vitalSigns[3]?.temperature ?? 0 }}</div>
      <div class="rp-text el-146">{{ vitalSigns[0]?.e4 ?? 0 }}</div>
      <div class="rp-text el-147">{{ vitalSigns[1]?.e4 ?? 0 }}</div>
      <div class="rp-text el-148">{{ vitalSigns[2]?.e4 ?? 0 }}</div>
      <div class="rp-text el-149">{{ vitalSigns[3]?.e4 ?? 0 }}</div>
      <div class="rp-text el-150">{{ vitalSigns[0]?.v5 ?? 0 }}</div>
      <div class="rp-text el-151">{{ vitalSigns[1]?.v5 ?? 0 }}</div>
      <div class="rp-text el-152">{{ vitalSigns[2]?.v5 ?? 0 }}</div>
      <div class="rp-text el-153">{{ vitalSigns[3]?.v5 ?? 0 }}</div>
      <div class="rp-text el-154">{{ vitalSigns[0]?.m6 ?? 0 }}</div>
      <div class="rp-text el-155">{{ vitalSigns[1]?.m6 ?? 0 }}</div>
      <div class="rp-text el-156">{{ vitalSigns[2]?.m6 ?? 0 }}</div>
      <div class="rp-text el-157">{{ vitalSigns[3]?.m6 ?? 0 }}</div>
      <div class="rp-text el-158">{{ vitalSigns[0]?.gcs ?? 0 }}</div>
      <div class="rp-text el-159">{{ vitalSigns[1]?.gcs ?? 0 }}</div>
      <div class="rp-text el-160">{{ vitalSigns[2]?.gcs ?? 0 }}</div>
      <div class="rp-text el-161">{{ vitalSigns[3]?.gcs ?? 0 }}</div>
      <div class="rp-text el-162">{{ vitalSigns[0]?.riskAlignment ?? 0 }}</div>
      <div class="rp-text el-163">{{ vitalSigns[1]?.riskAlignment ?? 0 }}</div>
      <div class="rp-text el-164">{{ vitalSigns[2]?.riskAlignment ?? 0 }}</div>
      <div class="rp-text el-165">{{ vitalSigns[3]?.riskAlignment ?? 0 }}</div>
      <div class="rp-panel el-166"></div>
      <div class="rp-text el-167">ارزیابی ثانویه</div>
      <div class="rp-text btnClick-168" :class="{ 'btnClick-168a': (flagShowForm == 3 || flagShowForm >= 5) }"
        @click="showAccompanyingSymptomsDialog = true"></div>
      <div class="rp-text el-168" :class="{ 'el-168a': flagShowForm >= 5 }">
        <v-icon class="ml-2" color="#0A6ADA" size="24">mdi mdi-text-box-edit-outline</v-icon>
        علائم همراه
      </div>
      <div class="rp-text el-170" :class="{ 'el-170a': flagShowForm >= 5 }">{{ getTitlesString(accompanyingSymptoms) }}
      </div>
      <template v-if="flagShowForm == 3">
        <div class="rp-text el-269">نشانه ها</div>
        <div class="rp-text el-255"
          :class="{ 'align-start': formatAllImportedData(accompanyingSymptoms_Info ?? [])?.length > 200 }">
          {{ formatAllImportedData(accompanyingSymptoms_Info ?? []) }}</div>
        <div class="rp-text el-256">زمان شروع علائم</div>
        <div class="rp-text el-257">{{ dateTimeChange(DataPatientById?.dateOfOnset) }}</div>
      </template>



      <div class="rp-text btnClick-172" @click="showDrugHistoryDialog = true"></div>
      <div class="rp-text el-172">
        <v-icon class="ml-2" color="#0A6ADA" size="24">mdi mdi-text-box-edit-outline</v-icon>
        سابقه مصرف دارو
      </div>
      <div class="rp-text btnClick-173" @click="showAllergyHistoryDialog = true"></div>
      <div class="rp-text el-173">
        <v-icon class="ml-2" color="#0A6ADA" size="24">mdi mdi-text-box-edit-outline</v-icon>
        سابقه حساسیت
      </div>
      <div class="rp-text btnClick-174" @click="showMedicalExaminationDialog = true"></div>
      <div class="rp-text el-174">
        <v-icon class="ml-2" color="#0A6ADA" size="24">mdi mdi-text-box-edit-outline</v-icon>
        آخرین وعده غذایی مصرفی
      </div>
      <div class="rp-text el-175"> {{ getTitlesString(drugHistory) }}</div>
      <div class="rp-text el-176"> {{ getTitlesString(allergyHistory) }}</div>
      <div class="rp-text el-177">
        {{ medicalExamination?.lastFood }} &nbsp; - &nbsp;
        <span>{{ dateTimeChange(medicalExamination?.lastFoodDate) }}</span>
      </div>
      <div class="rp-text btnClick-178" :class="{ 'el-btnClick-178a': (flagShowForm == 4) }"
        @click="showMedicalExaminationDialog = true"></div>
      <div class="rp-text el-178" :class="{ 'el-178a': (flagShowForm == 4) }">
        <v-icon class="ml-2" color="#0A6ADA" size="24">mdi mdi-text-box-edit-outline</v-icon>
        معاینات
      </div>
      <div class="rp-text el-179" :class="{ 'el-179a': (flagShowForm == 4) }">ریتم قلب</div>
      <div class="rp-text el-180" :class="{ 'el-180a': (flagShowForm == 4) }">سمع قلب</div>
      <div class="rp-text el-181" :class="{ 'el-181a': (flagShowForm == 4) }">سمع ریه</div>
      <div class="rp-text el-182" :class="{ 'el-182a': (flagShowForm == 4) }">راست</div>
      <div class="rp-text el-183" :class="{ 'el-183a': (flagShowForm == 4) }">چپ</div>
      <div class="rp-text el-184" :class="{ 'el-184a': (flagShowForm == 4) }">نبض</div>
      <div class="rp-text el-185" :class="{ 'el-185a': (flagShowForm == 4) }">{{
        medicalExamination?.heartRhythm?.title ??
        ''
        }}</div>
      <div class="rp-text el-186" :class="{ 'el-186a': (flagShowForm == 4) }">{{
        medicalExamination?.heartSound?.title ??
        ''
        }}</div>
      <div class="rp-text el-187" :class="{ 'el-187a': (flagShowForm == 4) }">
        {{ extractTrueKeys(medicalExamination?.patientRespiratorySoundDetail)?.right ?? '' }}
      </div>
      <div class="rp-text el-188" :class="{ 'el-188a': (flagShowForm == 4) }">
        {{ extractTrueKeys(medicalExamination?.patientRespiratorySoundDetail)?.left ?? '' }}
      </div>
      <div class="rp-text el-251" :class="{ 'el-251a': (flagShowForm == 4) }">کیفیت</div>
      <div class="rp-text el-252" :class="{ 'el-252a': (flagShowForm == 4) }">ریتم</div>
      <div class="rp-text el-253" :class="{ 'el-253a': (flagShowForm == 4) }">{{
        medicalExamination?.pulseRhythm?.title ??
        ''
        }}</div>
      <div class="rp-text el-189" :class="{ 'el-189a': (flagShowForm == 4) }">{{
        medicalExamination?.pulseQuality?.title
        ??
        '' }}</div>
      <div class="rp-text el-190" :class="{ 'el-190a': (flagShowForm == 4) }">پوست</div>
      <div class="rp-text el-195" :class="{ 'el-195a': (flagShowForm == 4) }">
        {{ medicalExamination?.skinTurgor?.title ?? '' }}
        &nbsp;/&nbsp;
        {{ medicalExamination?.skinExamination?.title ?? '' }}
      </div>

      <div class="rp-text el-191" :class="{ 'el-191b': flagShowForm == 3, 'el-191a': flagShowForm == 4 }">مردمک</div>
      <div class="rp-text el-192" :class="{ 'el-192b': flagShowForm == 3, 'el-192a': flagShowForm == 4 }">راست</div>
      <div class="rp-text el-193" :class="{ 'el-193a': flagShowForm == 3, 'el-193b': (flagShowForm == 4) }">چپ</div>
      <div class="rp-text el-196" :class="{ 'el-196a': flagShowForm == 3, 'el-196b': (flagShowForm == 4) }">
        {{ extractTrueKeys(medicalExamination?.patientPupilExamination)?.right ?? '' }}
      </div>
      <div class="rp-text el-197" :class="{ 'el-197b': flagShowForm == 3, 'el-197a': flagShowForm == 4 }">
        {{ extractTrueKeys(medicalExamination?.patientPupilExamination)?.left ?? '' }}
      </div>
      <template v-if="flagShowForm == 3">
        <div class="rp-text el-258" :class="{ 'el-258a': (flagShowForm == 4) }">قدرت عضلانی</div>
        <div class="rp-text el-259" :class="{ 'el-259a': (flagShowForm == 4) }">دست راست</div>
        <div class="rp-text el-260" :class="{ 'el-260a': (flagShowForm == 4) }">دست چپ</div>
        <div class="rp-text el-261" :class="{ 'el-261a': (flagShowForm == 4) }">
          {{ medicalExamination?.patientBrainStrokeExaminationDetail?.rightHand
            ? 'دست راست : ' + medicalExamination?.patientBrainStrokeExaminationDetail?.rightHand
            : '' }}
          {{ medicalExamination?.patientBrainStrokeExaminationDetail?.rightLeg
            ? 'پا راست : ' + medicalExamination?.patientBrainStrokeExaminationDetail?.rightLeg
            : '' }}
        </div>
        <div class="rp-text el-262" :class="{ 'el-262a': (flagShowForm == 4) }">
          {{ medicalExamination?.patientBrainStrokeExaminationDetail?.leftHand
            ? 'دست چپ : ' + medicalExamination?.patientBrainStrokeExaminationDetail?.leftHand
            : '' }}
          {{ medicalExamination?.patientBrainStrokeExaminationDetail?.leftLeg
            ? 'پا چپ : ' + medicalExamination?.patientBrainStrokeExaminationDetail?.leftLeg
            : '' }}
        </div>
      </template>

      <template v-if="flagShowForm !== 3">
        <div class="rp-text el-194" :class="{ 'el-194a': (flagShowForm == 4) }">شکم</div>
        <div class="rp-text el-198" :class="{ 'el-198a': (flagShowForm == 4) }">
          {{ formatAbdominalExaminations(medicalExamination?.patientAbdominalExaminations ?? []) }}</div>
      </template>

      <!-- <template v-if="flagShowForm == 4">
        <div class="rp-text el-199">عکس نوارقلب</div>
        <div class="rp-text el-263">{{ data.HeartbeatPhoto }}</div>
      </template> -->
      <div class="rp-text" :class="(flagShowForm == 3 || flagShowForm >= 5) ? 'btnClick-199' : 'btnClick-169'"
        @click="showMedicalHistoryDialog = true"></div>
      <div class="rp-text" :class="(flagShowForm == 3 || flagShowForm >= 5) ? 'el-199' : 'el-169'">
        <v-icon class="ml-2" color="#0A6ADA" size="24">mdi mdi-text-box-edit-outline</v-icon>
        تاریخچه پزشکی
      </div>
      <div class="rp-text" :class="(flagShowForm == 3 || flagShowForm >= 5) ? 'el-263' : 'el-171'">{{
        getTitlesString(medicalHistory) }}</div>

      <template v-if="flagShowForm == 1 || flagShowForm == 2">
        <div class="rp-text btnClick-199" @click="showBodyExaminationDialog = true"></div>
        <div class="rp-text el-199">
          <v-icon class="ml-2" color="#0A6ADA" size="24">mdi mdi-text-box-edit-outline</v-icon>
          معاینات سر تا پا
        </div>
        <div class="rp-text el-200">جلو</div>
        <div class="rp-text el-201">عقب</div>
        <div class="rp-text el-202">{{ bodyExamination?.front ?? '' }}</div>
        <div class="rp-text el-203">{{ bodyExamination?.back ?? '' }}</div>
      </template>

      <template v-if="flagShowForm == 1 ||
        (flagShowForm == 2 &&
          ['سقوط', 'سوختگی', 'برخورد با نیروی بی جان', 'حوادث عمدی']
            .includes(DetailByFollowup?.diagnosis))">
        <div class="rp-text btnClick-268" @click="showGeneralActionsDialog = true"></div>
        <div class="rp-text el-206">
          <v-icon class="ml-2" color="#0A6ADA" size="24">mdi mdi-text-box-edit-outline</v-icon>
          اقدامات مدیریت راه هوایی A
        </div>
        <div class="rp-text el-207">قبل</div>
        <div class="rp-text el-208">بعد</div>
        <div class="rp-text el-209">اقدامات مدیریت تنفس B</div>
        <div class="rp-text el-210">قبل</div>
        <div class="rp-text el-211">بعد</div>
        <div class="rp-text el-212">اقدامات مدیریت گردش خون C</div>
        <div class="rp-text el-213">قبل</div>
        <div class="rp-text el-214">بعد</div>
        <div class="rp-text el-215">بی حرکت سازی اندام ها</div>
        <div class="rp-text el-216">قبل</div>
        <div class="rp-text el-217">بعد</div>
        <div class="rp-text el-218">اقدامات حرکت اندام ها</div>
        <div class="rp-text el-219">قبل</div>
        <div class="rp-text el-220">بعد</div>
        <div class="rp-text el-221">{{ generalActions['اقدامات راه هوایی A']?.before }}</div>
        <div class="rp-text el-222">{{ generalActions['اقدامات راه هوایی A']?.after }}</div>
        <div class="rp-text el-223">{{ generalActions['اقدامات مدیریت تنفس B']?.before }}</div>
        <div class="rp-text el-224">{{ generalActions['اقدامات مدیریت تنفس B']?.after }}</div>
        <div class="rp-text el-225">{{ generalActions['اقدامات مدیریت گردش خون C']?.before }}</div>
        <div class="rp-text el-226">{{ generalActions['اقدامات مدیریت گردش خون C']?.after }}</div>
        <div class="rp-text el-227">{{ generalActions['بی حرکت سازی اندام']?.before }}</div>
        <div class="rp-text el-228">{{ generalActions['بی حرکت سازی اندام']?.after }}</div>
        <div class="rp-text el-229">{{ generalActions['اقدامات حرکت اندام ها']?.before }}</div>
        <div class="rp-text el-230">{{ generalActions['اقدامات حرکت اندام ها']?.after }}</div>
      </template>
      <template v-else>
        <div class="rp-text btnClick-268" @click="showGeneralActionsDialog = true"></div>
        <div class="rp-text el-264">
          <v-icon class="ml-2" color="#0A6ADA" size="24">mdi mdi-text-box-edit-outline</v-icon>
          اقدامات درمانی قبل
        </div>
        <div class="rp-text el-265">{{ generalActions['before'] }}</div>
        <div class="rp-text el-266">اقدامات درمانی بعد</div>
        <div class="rp-text el-267">{{ generalActions['after'] }}</div>

      </template>

      <div class="rp-text btnClick-231" @click="showTechnicianDrugsDialog = true"></div>
      <div class="rp-text el-231">
        <v-icon class="ml-2" color="#0A6ADA" size="24">mdi mdi-text-box-edit-outline</v-icon>
        داروها
      </div>
      <div class="rp-text el-240">{{ technicianDrugs }}</div>

      <div class="rp-text btnClick-232" @click="showMedicalItemsDialog = true"></div>
      <div class="rp-text el-232">
        <v-icon class="ml-2" color="#0A6ADA" size="24">mdi mdi-text-box-edit-outline</v-icon>
        اقلام مصرفی
      </div>
      <div class="rp-text el-241">{{ medicalItems }}</div>

      <div class="rp-text btnClick-233" @click="showPatientResultDialog = true"></div>
      <div class="rp-text el-233">
        <v-icon class="ml-2" color="#0A6ADA" size="24">mdi mdi-text-box-edit-outline</v-icon>
        توضیحات تکنسین
      </div>
      <div class="rp-text el-242">{{ patientResult?.note ?? '' }}</div>

      <div class="rp-text el-234">نتیجه ماموریت</div>
      <div class="rp-text el-235">
        {{ patientResult?.result?.title ?? '' }}
        {{ patientResult?.information ? ' - ' + patientResult?.information : '' }}
      </div>

      <!-- <div class="rp-text el-236">نام مرکز درمانی</div>
      <div class="rp-text el-237">{{ data.Hospital }}</div> -->

      <!-- <div class="rp-text el-243">تاریخ / ساعت تحویل به مرکز درمانی</div>
      <div class="rp-text el-244">{{ data.DeliverToHospitalDatePersian }} {{ data.DeliverToHospitalTime }}</div> -->
    </template>
  </div>
</template>

<script>
import Vue from 'vue';
import SharedHelper from '@/Helpers/Shared';
import SharedMixin from '@/Mixins/Shared';
import ReportFormFollowUpMixin from '@/Mixins/FollowUp/FollowUpPatientPart/ReportFormFollowUpMixin.js';
import FollowUpPatientStep4Component from '@/components/FollowUp/Dialogs/FollowUpPatientStep4Component.vue';
import FollowUpPatientStep5Component from '@/components/FollowUp/Dialogs/FollowUpPatientStep5Component.vue';
import FollowUpPatientStep6Component from '@/components/FollowUp/Dialogs/FollowUpPatientStep6Component.vue';
import FollowUpPatientStep7Component from '@/components/FollowUp/Dialogs/FollowUpPatientStep7Component.vue';
import FollowUpPatientStep8Component from '@/components/FollowUp/Dialogs/FollowUpPatientStep8Component.vue';
import FollowUpPatientStep9Component from '@/components/FollowUp/Dialogs/FollowUpPatientStep9Component.vue';
import FollowUpPatientStep10Component from '@/components/FollowUp/Dialogs/FollowUpPatientStep10Component.vue';
import FollowUpPatientStep11Component from '@/components/FollowUp/Dialogs/FollowUpPatientStep11Component.vue';
import FollowUpPatientStep12Component from '@/components/FollowUp/Dialogs/FollowUpPatientStep12Component.vue';
import FollowUpPatientStep13Component from '@/components/FollowUp/Dialogs/FollowUpPatientStep13Component.vue';
import FollowUpPatientStep14Component from '@/components/FollowUp/Dialogs/FollowUpPatientStep14Component.vue';

export default {
  title: 'فرم گزارش پیگیری',
  name: 'ReportFormFollowUp',
  inject: ['load'],
  mixins: [SharedHelper, SharedMixin, ReportFormFollowUpMixin],
  components: {
    FollowUpPatientStep4Component,
    FollowUpPatientStep5Component,
    FollowUpPatientStep6Component,
    FollowUpPatientStep7Component,
    FollowUpPatientStep8Component,
    FollowUpPatientStep9Component,
    FollowUpPatientStep10Component,
    FollowUpPatientStep11Component,
    FollowUpPatientStep12Component,
    FollowUpPatientStep13Component,
    FollowUpPatientStep14Component
  },
  props: {
    patientId: {
      type: Number,
      require: true,
      default: null,
    },
    missionType: {
      type: String,
      require: true,
      default: '',
    },
    missionPhoneId: {
      type: Number,
      require: true,
      default: null,
    },
    data: {
      type: Object,
      default: () => ({
        Signs: '',
        Abdominal: '',
        HeartbeatPhoto: '',
        MissionDatePersian: '',
        PhoneCode: '',
        Hospital: '',
        DeliverToHospitalDatePersian: '',
        DeliverToHospitalTime: '',
      })
    }
  },
  data() {
    return {}
  },
  created() {
    this.$root.$refs.ReportFormFollowUp = this;
  },
  mounted() {
    this.mounteLoding();
  },
  methods: {
    mounte: function () {
      //1
      this.getPatientByIdFunction_RFF(this.patientId);
      //2
      this.getPatientInitialAssessmentByIdFunction_RFF(this.patientId);
      //3
      this.getPatientDetailByFollowupFunction_RFF(this.patientId);
      //4
      this.getAllPatientVitalSignFunction_RFF(this.patientId);
      //5
      this.getAllPatientAccompanyingSymptomFunction_RFF(this.patientId);
      //6
      this.getAllPatientMedicalHistoryFunction_RFF(this.patientId);
      //7
      this.getAllPatientDrugHistoryFunction_RFF(this.patientId);
      //8
      this.getAllPatientAllergyHistoryFunction_RFF(this.patientId);
      //9
      this.getPatientMedicalExaminationByIdFunction_RFF(this.patientId);
      //10
      this.getAllPatientBodyExaminationFunction_RFF(this.patientId);
      //11
      this.getAllPatientGeneralActionFunction_RFF(this.patientId);
      //12
      this.getAllPatientTechnicianDrugFunction_RFF(this.patientId);
      //13
      this.getAllPatientMedicalItemFunction_RFF(this.patientId);
      //14
      this.getPatientResultByIdFunction_RFF(this.patientId);
    },
    getTitleById(list, id) {
      const found = list.find(item => item.id === id);
      return found?.title || 'نامشخص';
    },
    dateTimeChange: function (time) {
      if (time) {
        return Vue.moment(time).format('HH:mm:ss jYYYY-jMM-jDD',);
      }
      return ''
    },
    getTitlesString(dataArray) {
      if (!dataArray || dataArray.length === 0) return '';
      return dataArray
        .filter(item => item?.title)
        .map(item => item.title)
        .join(' ، ');
    },
    reloadApiFun(type, isNext = false, numNext = 0) {
      const apiMap = {
        2: this.getAllPatientVitalSignFunction_RFF,
        3: this.getAllPatientAccompanyingSymptomFunction_RFF,
        4: this.getAllPatientMedicalHistoryFunction_RFF,
        5: this.getAllPatientDrugHistoryFunction_RFF,
        6: this.getAllPatientAllergyHistoryFunction_RFF,
        7: this.getPatientMedicalExaminationByIdFunction_RFF,
        8: this.getAllPatientBodyExaminationFunction_RFF,
        9: this.getAllPatientGeneralActionFunction_RFF,
        10: this.getAllPatientTechnicianDrugFunction_RFF,
        11: this.getAllPatientMedicalItemFunction_RFF,
        12: this.getPatientResultByIdFunction_RFF,
        13: '',

      };
      const dialogClose = {
        2: () => { this.showVitalSignsDialog = false; },
        3: () => { this.showAccompanyingSymptomsDialog = false; },
        4: () => { this.showMedicalHistoryDialog = false; },
        5: () => { this.showDrugHistoryDialog = false; },
        6: () => { this.showAllergyHistoryDialog = false; },
        7: () => { this.showMedicalExaminationDialog = false; },
        8: () => { this.showBodyExaminationDialog = false; },
        9: () => { this.showGeneralActionsDialog = false; },
        10: () => { this.showTechnicianDrugsDialog = false; },
        11: () => { this.showMedicalItemsDialog = false; },
        12: () => { this.showPatientResultDialog = false; },
        13: '',
      };

      const api = apiMap[type];
      if (api) {
        if (dialogClose[type]) {
          dialogClose[type]();
        }
        if (isNext) {
          this.goToNextDialog(numNext)
        }
        api(this.patientId);
      } else {
        console.warn('نوع نامعتبر:', type);
      }
    },
    goToNextDialog(type) {
      const nextDialg = {
        3: () => { this.showAccompanyingSymptomsDialog = true; },
        4: () => { this.showMedicalHistoryDialog = true; },
        5: () => { this.showDrugHistoryDialog = true; },
        6: () => { this.showAllergyHistoryDialog = true; },
        7: () => { this.showMedicalExaminationDialog = true; },
        8: () => { this.showBodyExaminationDialog = true; },
        9: () => { this.showGeneralActionsDialog = true; },
        10: () => { this.showTechnicianDrugsDialog = true; },
        11: () => { this.showMedicalItemsDialog = true; },
        12: () => { this.showPatientResultDialog = true; },
      };

      const nextD = nextDialg[type];
      if (nextD) {
        nextD(type);
        this.reloadApiFun(type - 1)
      } else {
        console.warn('نوع نامعتبر:', type);
      }
    },
    extractTrueKeys(obj) {
      const translate = {
        leftCoarseRale: "رال کورس",
        leftFineRale: "رال فابین",
        leftSoundReduction: "کاهش صدا",
        leftWheeze: "ویز",
        rightCoarseRale: "رال کورس",
        rightFineRale: "رال فابین",
        rightSoundReduction: "کاهش صدا",
        rightWheeze: "ویز",
        leftDilate: "دیلاته",
        leftMiotic: "میوتیک",
        leftNoAnswer: "بدون پاسخ",
        leftNormal: "نرمال",
        rightDilate: "دیلاته",
        rightMiotic: "میوتیک",
        rightNoAnswer: "بدون پاسخ",
        rightNormal: "نرمال",
        rightHand: "دست راست",
        leftHand: "دست چپ",
        leftLeg: "پا چپ",
        rightLeg: "پا راست",
      };

      if (obj && typeof obj === 'object' && !Array.isArray(obj)) {
        const leftKeys = Object.keys(obj)
          .filter(subKey => subKey.toLowerCase().includes('left') && obj[subKey] === true)
          .map(subKey => translate[subKey] || subKey)
          .join('، ');

        const rightKeys = Object.keys(obj)
          .filter(subKey => subKey.toLowerCase().includes('right') && obj[subKey] === true)
          .map(subKey => translate[subKey] || subKey)
          .join('، ');

        const allKeys = Object.keys(obj)
          .filter(subKey => obj[subKey] === true)
          .map(subKey => translate[subKey] || subKey)
          .join('، ');

        return {
          left: leftKeys || '',
          right: rightKeys || '',
          all: allKeys || '',
        };
      }

      return { left: '', right: '', all: '' };
    },
    formatAbdominalExaminations(data) {
      if (!data || data?.length == 0) return ''
      return data.reduce((acc, item, index) => {
        const titles = item.abdomenExaminations.map(exam => exam.title).join('، ');
        const text = `(${titles}-${item.partNumber})`;
        return acc + (index === 0 ? '' : '، ') + text;
      }, '');
    },
    formatAllImportedData(importedData) {
      if (!importedData?.length) return '';

      return importedData
        .map(item => {
          if (!item.info?.length) {
            return `(${item.title})`;
          }
          const infoString = item.info
            .map(info => `${info.content}: ${info.title}`)
            .join(' ، ');
          return `(${item.title}: ${infoString})`;
        })
        .join(' ، ');
    }

  },
}
</script>

<style scoped>
.rp-page {
  position: relative;
  box-sizing: border-box;
  /* width: 1000; */
  min-width: 1180px;
  max-width: 1280px;
  height: 1550px;
  margin: 0 auto;
  padding: 19px 38px;
  background: #fff;
  box-shadow: 0 0 8px rgba(0, 0, 0, 0.2);
  overflow: hidden;
  /* font-family: 'B Yekan', 'Vazirmatn', Tahoma, sans-serif; */
  font-family: 'Yekan-Bakh-Regular' !important;
  color: #000;
  direction: ltr;
  display: grid;
  grid-template-columns: 67.2fr 28.8fr 19.2fr 19.2fr 9.6fr 9.6fr 9.6fr 9.6fr 19.2fr 9.6fr 9.6fr 9.6fr 19.2fr 9.6fr 9.6fr 19.2fr 9.6fr 9.6fr 9.6fr 9.6fr 9.6fr 19.2fr 9.6fr 9.6fr 9.6fr 9.6fr 38.4fr 9.6fr 9.6fr 19.2fr 9.6fr 9.6fr 9.6fr 9.6fr 19.2fr 9.6fr 9.6fr 19.2fr 19.2fr 9.6fr 9.6fr 19.2fr 9.6fr 19.2fr 19.2fr 9.6fr 19.2fr 57.6fr 6.72fr;
  grid-template-rows: 0fr 0fr 0fr 0fr 0fr 19.2fr 28.8fr 28.8fr 28.8fr 28.8fr 0fr 0fr 0fr 0fr 0fr 0fr 19.2fr 28.8fr 0fr 0fr 19.2fr 19.2fr 19.2fr 19.2fr 19.2fr 19.2fr 19.2fr 19.2fr 19.2fr 57.6fr 19.2fr 57.6fr 19.2fr 19.2fr 19.2fr 19.2fr 19.2fr 19.2fr 19.2fr 0fr 28.8fr 19.2fr 105.6fr 19.2fr 19.2fr 19.2fr 19.2fr 19.2fr 19.2fr 19.2fr 19.2fr;
}

::v-deep .v-dialog:not(.v-dialog--fullscreen) {
  max-height: 95% !important;
}


.rp-panel,
.rp-text {
  box-sizing: border-box;
  /* font-family: 'B Yekan', 'Vazirmatn', Tahoma, sans-serif; */
  font-family: 'Yekan-Bakh-Regular' !important;
}

.rp-text {
  display: flex;
  white-space: pre-line;
  overflow: hidden;
  padding: 0 2px;
  direction: rtl;
}

.el-0 {
  grid-column: 1 / 50;
  grid-row: 1 / 6;
  background: transparent;
}

.el-1 {
  grid-column: 46 / 49;
  grid-row: 1 / 2;
  font-size: 10.0pt;
  font-weight: bold;
  color: #000;
  align-items: center;
  justify-content: center;
  text-align: right;
}

.el-2 {
  grid-column: 34 / 46;
  grid-row: 1 / 2;
  font-size: 10.0pt;
  color: #000;
  align-items: center;
  justify-content: center;
  text-align: right;
}

.el-3 {
  grid-column: 46 / 49;
  grid-row: 2 / 3;
  font-size: 10.0pt;
  font-weight: bold;
  color: #000;
  align-items: center;
  justify-content: center;
  text-align: right;
}

.el-4 {
  grid-column: 34 / 46;
  grid-row: 2 / 3;
  font-size: 10.0pt;
  color: #000;
  align-items: center;
  justify-content: center;
  text-align: right;
}

.el-5 {
  grid-column: 46 / 49;
  grid-row: 3 / 4;
  font-size: 10.0pt;
  font-weight: bold;
  color: #000;
  align-items: center;
  justify-content: center;
  text-align: right;
}

.el-6 {
  grid-column: 34 / 46;
  grid-row: 3 / 4;
  font-size: 10.0pt;
  color: #000;
  align-items: center;
  justify-content: center;
  text-align: right;
}

.el-7 {
  grid-column: 16 / 33;
  grid-row: 1 / 4;
  font-size: 10.0pt;
  font-weight: bold;
  color: #000;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.el-8 {
  grid-column: 46 / 49;
  grid-row: 4 / 5;
  font-size: 10.0pt;
  font-weight: bold;
  color: #000;
  align-items: center;
  justify-content: center;
  text-align: right;
}

.el-9 {
  grid-column: 34 / 46;
  grid-row: 4 / 5;
  font-size: 10.0pt;
  color: #000;
  align-items: center;
  justify-content: center;
  text-align: right;
}

.el-10 {
  grid-column: 46 / 49;
  grid-row: 5 / 6;
  font-size: 10.0pt;
  font-weight: bold;
  color: #000;
  align-items: center;
  justify-content: center;
  text-align: right;
}

.el-11 {
  grid-column: 34 / 46;
  grid-row: 5 / 6;
  font-size: 10.0pt;
  color: #000;
  align-items: center;
  justify-content: center;
  text-align: right;
}

.el-12 {
  grid-column: 1 / 49;
  grid-row: 6 / 52;
  background: transparent;
  border: 1px solid #000;
}

.el-13 {
  grid-column: 1 / 49;
  grid-row: 6 / 7;
  background: rgb(238, 236, 225);
  border: 1px solid #000;
}

.el-14 {
  grid-column: 1 / 49;
  grid-row: 6 / 7;
  font-size: 12.0pt;
  font-weight: bold;
  color: #000;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.el-15 {
  grid-column: 31 / 49;
  grid-row: 7 / 8;
  background: transparent;
  border: 1px solid #000;
}

.el-16 {
  grid-column: 31 / 45;
  grid-row: 7 / 8;
  font-size: 10.0pt;
  color: #000;
  border-left: 1px solid #000;
  border-bottom: 1px solid #000;
  align-items: center;
  justify-content: center;
  text-align: right;
}

.el-17 {
  grid-column: 45 / 49;
  grid-row: 7 / 8;
  font-size: 10.0pt;
  font-weight: bold;
  color: #000;
  border-top: 1px solid #000;
  border-right: 1px solid #000;
  border-bottom: 1px solid #000;
  align-items: center;
  justify-content: center;
  text-align: right;
}

.el-18 {
  grid-column: 24 / 31;
  grid-row: 7 / 8;
  background: transparent;
  border: 1px solid #000;
}

.el-19 {
  grid-column: 24 / 29;
  grid-row: 7 / 8;
  font-size: 10.0pt;
  color: #000;
  border-left: 1px solid #000;
  border-bottom: 1px solid #000;
  align-items: center;
  justify-content: center;
  text-align: right;
}

.el-20 {
  grid-column: 29 / 31;
  grid-row: 7 / 8;
  font-size: 10.0pt;
  font-weight: bold;
  color: #000;
  border-top: 1px solid #000;
  border-right: 1px solid #000;
  border-bottom: 1px solid #000;
  align-items: center;
  justify-content: center;
  text-align: right;
}

.el-21 {
  grid-column: 14 / 24;
  grid-row: 7 / 8;
  background: transparent;
  border: 1px solid #000;
}

.el-22 {
  grid-column: 14 / 21;
  grid-row: 7 / 8;
  font-size: 10.0pt;
  color: #000;
  border-left: 1px solid #000;
  border-bottom: 1px solid #000;
  align-items: center;
  justify-content: center;
  text-align: right;
}

.el-23 {
  grid-column: 21 / 24;
  grid-row: 7 / 8;
  font-size: 10.0pt;
  font-weight: bold;
  color: #000;
  border-top: 1px solid #000;
  border-right: 1px solid #000;
  border-bottom: 1px solid #000;
  align-items: center;
  justify-content: center;
  text-align: right;
}

.el-24 {
  grid-column: 6 / 14;
  grid-row: 7 / 8;
  background: transparent;
  border: 1px solid #000;
}

.el-25 {
  grid-column: 11 / 14;
  grid-row: 7 / 8;
  font-size: 10.0pt;
  font-weight: bold;
  color: #000;
  border-top: 1px solid #000;
  border-right: 1px solid #000;
  border-bottom: 1px solid #000;
  align-items: center;
  justify-content: center;
  text-align: right;
}

.el-26 {
  grid-column: 6 / 11;
  grid-row: 7 / 8;
  font-size: 10.0pt;
  color: #000;
  border-left: 1px solid #000;
  border-bottom: 1px solid #000;
  align-items: center;
  justify-content: center;
  text-align: right;
}

.el-27 {
  grid-column: 1 / 6;
  grid-row: 7 / 8;
  background: transparent;
  border: 1px solid #000;
}

.el-28 {
  grid-column: 1 / 3;
  grid-row: 7 / 8;
  font-size: 10.0pt;
  color: #000;
  border-left: 1px solid #000;
  border-bottom: 1px solid #000;
  align-items: center;
  justify-content: center;
  text-align: right;
}

.el-29 {
  grid-column: 3 / 6;
  grid-row: 7 / 8;
  font-size: 10.0pt;
  font-weight: bold;
  color: #000;
  border-top: 1px solid #000;
  border-right: 1px solid #000;
  border-bottom: 1px solid #000;
  align-items: center;
  justify-content: center;
  text-align: right;
}

.el-30 {
  grid-column: 38 / 49;
  grid-row: 8 / 9;
  background: transparent;
  border: 1px solid #000;
}

.el-31 {
  grid-column: 38 / 45;
  grid-row: 8 / 9;
  font-size: 10.0pt;
  color: #000;
  border-left: 1px solid #000;
  border-bottom: 1px solid #000;
  align-items: center;
  justify-content: center;
  text-align: right;
}

.el-32 {
  grid-column: 45 / 49;
  grid-row: 8 / 9;
  font-size: 10.0pt;
  font-weight: bold;
  color: #000;
  border-top: 1px solid #000;
  border-right: 1px solid #000;
  border-bottom: 1px solid #000;
  align-items: center;
  justify-content: center;
  text-align: right;
}

.el-33 {
  grid-column: 20 / 38;
  grid-row: 8 / 9;
  background: transparent;
  border: 1px solid #000;
}

.el-34 {
  grid-column: 20 / 30;
  grid-row: 8 / 9;
  font-size: 10.0pt;
  color: #000;
  border-left: 1px solid #000;
  border-bottom: 1px solid #000;
  align-items: center;
  justify-content: center;
  text-align: right;
}

.el-35 {
  grid-column: 30 / 38;
  grid-row: 8 / 9;
  font-size: 10.0pt;
  font-weight: bold;
  color: #000;
  border-top: 1px solid #000;
  border-right: 1px solid #000;
  border-bottom: 1px solid #000;
  align-items: center;
  justify-content: center;
  text-align: right;
}

.el-36 {
  grid-column: 1 / 17;
  grid-row: 8 / 11;
  background: transparent;
}

.el-39 {
  grid-column: 3 / 13;
  grid-row: 9 / 10;
  font-size: 10.0pt;
  color: #000;
  border: 1px solid #000;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.el-40 {
  grid-column: 3 / 13;
  grid-row: 10 / 11;
  font-size: 10.0pt;
  color: #000;
  border: 1px solid #000;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.el-44 {
  grid-column: 3 / 13;
  grid-row: 8 / 9;
  font-size: 10.0pt;
  font-weight: bold;
  color: #000;
  background: rgb(238, 236, 225);
  border: 1px solid #000;
  align-items: center;
  justify-content: center;
  text-align: center;
}


.el-37 {
  /* grid-column: 13 / 20; */
  grid-column: 45 / 49;
  grid-row: 10 / 11;
  font-size: 10.0pt;
  font-weight: bold;
  color: #000;
  background: rgb(238, 236, 225);
  border: 1px solid #000;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.el-38 {
  /* grid-column: 13 / 20; */
  grid-column: 45 / 49;
  grid-row: 9 / 10;
  font-size: 10.0pt;
  font-weight: bold;
  color: #000;
  background: rgb(238, 236, 225);
  border: 1px solid #000;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.el-41 {
  /* grid-column: 1 / 3; */
  grid-column: 34 / 45;
  grid-row: 9 / 10;
  font-size: 10.0pt;
  color: #000;
  border: 1px solid #000;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.el-42 {
  /* grid-column: 1 / 3; */
  grid-column: 34 / 45;
  grid-row: 10 / 11;
  font-size: 10.0pt;
  color: #000;
  border: 1px solid #000;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.el-43 {
  /* grid-column: 13 / 20; */
  grid-column: 45 / 49;
  grid-row: 8 / 9;
  font-size: 10.0pt;
  font-weight: bold;
  color: #000;
  background: rgb(238, 236, 225);
  border: 1px solid #000;
  align-items: center;
  justify-content: center;
  text-align: center;
}


.el-45 {
  /* grid-column: 1 / 3; */
  grid-column: 34 / 49;
  grid-row: 8 / 9;
  font-size: 10.0pt;
  font-weight: bold;
  color: #000;
  background: rgb(238, 236, 225);
  border: 1px solid #000;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.el-46 {
  grid-column: 20 / 49;
  grid-row: 9 / 11;
  background: transparent;
  border: 1px solid #000;
}

.el-47 {
  grid-column: 20 / 45;
  grid-row: 9 / 11;
  font-size: 10.0pt;
  color: #000;
  border-left: 1px solid #000;
  border-bottom: 1px solid #000;
  align-items: center;
  justify-content: center;
  text-align: right;
}

.el-48 {
  grid-column: 45 / 49;
  grid-row: 9 / 11;
  font-size: 10.0pt;
  font-weight: bold;
  color: #000;
  border-top: 1px solid #000;
  border-right: 1px solid #000;
  border-bottom: 1px solid #000;
  align-items: center;
  justify-content: center;
  text-align: right;
}

.el-49 {
  grid-column: 1 / 49;
  grid-row: 11 / 12;
  background: rgb(238, 236, 225);
  border: 1px solid #000;
}

.el-50 {
  grid-column: 1 / 10;
  grid-row: 11 / 12;
  font-size: 12.0pt;
  font-weight: bold;
  color: #000;
  border: 1px solid #000;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.el-51 {
  grid-column: 10 / 49;
  grid-row: 11 / 12;
  font-size: 12.0pt;
  font-weight: bold;
  color: #000;
  border: 1px solid #000;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.el-52 {
  grid-column: 39 / 49;
  grid-row: 13 / 14;
  background: transparent;
  border: 1px solid #000;
}

.el-53 {
  grid-column: 39 / 44;
  grid-row: 13 / 14;
  font-size: 10.0pt;
  color: #000;
  border: 1px solid #000;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.el-54 {
  grid-column: 44 / 49;
  grid-row: 13 / 14;
  font-size: 10.0pt;
  font-weight: bold;
  color: #000;
  background: rgb(238, 236, 225);
  border: 1px solid #000;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.el-55 {
  grid-column: 25 / 39;
  grid-row: 13 / 14;
  background: transparent;
  border: 1px solid #000;
}

.el-56 {
  grid-column: 25 / 29;
  grid-row: 13 / 14;
  font-size: 10.0pt;
  color: #000;
  border: 1px solid #000;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.el-57 {
  grid-column: 29 / 39;
  grid-row: 13 / 14;
  font-size: 10.0pt;
  font-weight: bold;
  color: #000;
  background: rgb(238, 236, 225);
  border: 1px solid #000;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.el-58 {
  grid-column: 10 / 25;
  grid-row: 13 / 15;
  background: transparent;
  border: 1px solid #000;
}

.el-59 {
  grid-column: 10 / 16;
  grid-row: 13 / 15;
  font-size: 10.0pt;
  color: #000;
  border: 1px solid #000;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.el-60 {
  grid-column: 16 / 25;
  grid-row: 13 / 15;
  font-size: 10.0pt;
  font-weight: bold;
  color: #000;
  background: rgb(238, 236, 225);
  border: 1px solid #000;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.el-61 {
  grid-column: 39 / 49;
  grid-row: 14 / 16;
  background: transparent;
  border: 1px solid #000;
}

.el-62 {
  grid-column: 39 / 44;
  grid-row: 14 / 16;
  font-size: 10.0pt;
  color: #000;
  border: 1px solid #000;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.el-63 {
  grid-column: 44 / 49;
  grid-row: 14 / 16;
  font-size: 10.0pt;
  font-weight: bold;
  color: #000;
  background: rgb(238, 236, 225);
  border: 1px solid #000;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.el-64 {
  grid-column: 25 / 39;
  grid-row: 14 / 16;
  background: transparent;
  border: 1px solid #000;
}

.el-65 {
  grid-column: 25 / 29;
  grid-row: 14 / 16;
  font-size: 10.0pt;
  color: #000;
  border: 1px solid #000;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.el-66 {
  grid-column: 29 / 39;
  grid-row: 14 / 16;
  font-size: 10.0pt;
  font-weight: bold;
  color: #000;
  background: rgb(238, 236, 225);
  border: 1px solid #000;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.el-67 {
  grid-column: 10 / 25;
  grid-row: 15 / 17;
  background: transparent;
  border: 1px solid #000;
}

.el-68 {
  grid-column: 10 / 16;
  grid-row: 15 / 17;
  font-size: 10.0pt;
  color: #000;
  border: 1px solid #000;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.el-69 {
  grid-column: 16 / 25;
  grid-row: 15 / 17;
  font-size: 10.0pt;
  font-weight: bold;
  color: #000;
  background: rgb(238, 236, 225);
  border: 1px solid #000;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.el-70 {
  grid-column: 39 / 49;
  grid-row: 16 / 17;
  background: transparent;
  border: 1px solid #000;
}

.el-71 {
  grid-column: 39 / 49;
  grid-row: 16 / 17;
  background: transparent;
  border: 1px solid #000;
}

.el-72 {
  grid-column: 39 / 44;
  grid-row: 16 / 17;
  font-size: 10.0pt;
  color: #000;
  border: 1px solid #000;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.el-73 {
  grid-column: 44 / 49;
  grid-row: 16 / 17;
  font-size: 10.0pt;
  font-weight: bold;
  color: #000;
  background: rgb(238, 236, 225);
  border: 1px solid #000;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.el-74 {
  grid-column: 25 / 39;
  grid-row: 16 / 17;
  background: transparent;
  border: 1px solid #000;
}

.el-75 {
  grid-column: 25 / 39;
  grid-row: 16 / 17;
  background: transparent;
  border: 1px solid #000;
}

.el-76 {
  grid-column: 25 / 29;
  grid-row: 16 / 17;
  font-size: 10.0pt;
  color: #000;
  border: 1px solid #000;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.el-77 {
  grid-column: 29 / 39;
  grid-row: 16 / 17;
  font-size: 10.0pt;
  font-weight: bold;
  color: #000;
  background: rgb(238, 236, 225);
  border: 1px solid #000;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.el-78 {
  grid-column: 3 / 10;
  grid-row: 12 / 13;
  font-size: 10.0pt;
  font-weight: bold;
  color: #000;
  background: rgb(238, 236, 225);
  border: 1px solid #000;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.el-79 {
  grid-column: 3 / 10;
  grid-row: 13 / 14;
  font-size: 10.0pt;
  font-weight: bold;
  color: #000;
  background: rgb(238, 236, 225);
  border: 1px solid #000;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.el-80 {
  grid-column: 3 / 10;
  grid-row: 14 / 16;
  font-size: 10.0pt;
  font-weight: bold;
  color: #000;
  background: rgb(238, 236, 225);
  border: 1px solid #000;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.el-81 {
  grid-column: 3 / 10;
  grid-row: 16 / 17;
  font-size: 10.0pt;
  font-weight: bold;
  color: #000;
  background: rgb(238, 236, 225);
  border: 1px solid #000;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.el-82 {
  grid-column: 1 / 3;
  grid-row: 12 / 13;
  font-size: 10.0pt;
  color: #000;
  border: 1px solid #000;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.el-83 {
  grid-column: 1 / 3;
  grid-row: 13 / 14;
  font-size: 10.0pt;
  color: #000;
  border: 1px solid #000;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.el-84 {
  grid-column: 1 / 3;
  grid-row: 14 / 16;
  font-size: 10.0pt;
  color: #000;
  border: 1px solid #000;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.el-85 {
  grid-column: 1 / 3;
  grid-row: 16 / 17;
  font-size: 10.0pt;
  color: #000;
  border: 1px solid #000;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.el-86 {
  grid-column: 1 / 49;
  grid-row: 17 / 18;
  background: rgb(238, 236, 225);
  border: 1px solid #000;
}

.el-87 {
  grid-column: 16 / 33;
  grid-row: 17 / 18;
  font-size: 12.0pt;
  font-weight: bold;
  color: #000;
  border-top: 1px solid #000;
  border-bottom: 1px solid #000;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.el-88 {
  grid-column: 43 / 49;
  grid-row: 18 / 19;
  font-size: 10.0pt;
  color: #000;
  border: 1px solid #000;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.el-88a {
  grid-column: 36 / 49;
}

.el-89 {
  grid-column: 33 / 43;
  grid-row: 18 / 19;
  font-size: 10.0pt;
  color: #000;
  border: 1px solid #000;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.el-89a {
  grid-column: 24 / 36;
}

.el-90 {
  grid-column: 23 / 33;
  grid-row: 18 / 19;
  font-size: 10.0pt;
  color: #000;
  border: 1px solid #000;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.el-90a {
  grid-column: 12 / 24;
}

.el-91 {
  grid-column: 12 / 23;
  grid-row: 18 / 19;
  font-size: 10.0pt;
  color: #000;
  border: 1px solid #000;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.el-91a {
  grid-column: 1 / 12;
}

.el-92 {
  grid-column: 1 / 12;
  grid-row: 18 / 19;
  font-size: 10.0pt;
  color: #000;
  border: 1px solid #000;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.el-93 {
  /* grid-column: 1 / 49;
  grid-row: 19 / 20; */
  grid-column: 1 / 34;
  grid-row: 8 / 9;
  background: rgb(238, 236, 225);
  border: 1px solid #000;
}

.el-94 {
  /* grid-column: 16 / 33;
  grid-row: 19 / 20; */
  grid-column: 1 / 34;
  grid-row: 8 / 9;
  font-size: 12.0pt;
  font-weight: bold;
  color: #000;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.el-95 {
  /* grid-column: 48 / 49;
  grid-row: 20 / 21; */
  grid-column: 25 / 34;
  grid-row: 9 / 10;
  font-size: 10.0pt;
  font-weight: bold;
  color: #000;
  background: rgb(238, 236, 225);
  border: 1px solid #000;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.el-96 {
  /* grid-column: 41 / 48;
  grid-row: 20 / 21; */
  grid-column: 25 / 34;
  grid-row: 10 / 11;
  font-size: 10.0pt;
  color: #000;
  border: 1px solid #000;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.el-97 {
  /* grid-column: 35 / 41;
  grid-row: 20 / 21; */
  grid-column: 17 / 25;
  grid-row: 9 / 10;
  font-size: 10.0pt;
  font-weight: bold;
  color: #000;
  background: rgb(238, 236, 225);
  border: 1px solid #000;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.el-98 {
  /* grid-column: 27 / 35;
  grid-row: 20 / 21; */
  grid-column: 17 / 25;
  grid-row: 10 / 11;
  font-size: 10.0pt;
  color: #000;
  border: 1px solid #000;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.el-99 {
  /* grid-column: 19 / 27;
  grid-row: 20 / 21; */
  grid-column: 9 / 17;
  grid-row: 9 / 10;
  font-size: 10.0pt;
  font-weight: bold;
  color: #000;
  background: rgb(238, 236, 225);
  border: 1px solid #000;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.el-100 {
  /* grid-column: 9 / 19;
  grid-row: 20 / 21; */
  grid-column: 9 / 17;
  grid-row: 10 / 11;
  font-size: 10.0pt;
  color: #000;
  border: 1px solid #000;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.el-101 {
  /* grid-column: 4 / 9;
  grid-row: 20 / 21; */
  grid-column: 1 / 9;
  grid-row: 9 / 10;
  font-size: 10.0pt;
  font-weight: bold;
  color: #000;
  background: rgb(238, 236, 225);
  border: 1px solid #000;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.el-102 {
  /* grid-column: 1 / 4;
  grid-row: 20 / 21; */
  grid-column: 1 / 9;
  grid-row: 10 / 11;
  font-size: 10.0pt;
  color: #000;
  border: 1px solid #000;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.el-103 {
  grid-column: 1 / 49;
  grid-row: 21 / 22;
  background: rgb(238, 236, 225);
  border: 1px solid #000;
}

.el-104 {
  grid-column: 1 / 49;
  grid-row: 21 / 22;
  font-size: 12.0pt;
  font-weight: bold;
  color: #000;
  border-top: 1px solid #000;
  border-bottom: 1px solid #000;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.el-105 {
  grid-column: 1 / 7;
  grid-row: 22 / 24;
  font-size: 10.0pt;
  font-weight: bold;
  color: #000;
  background: rgb(238, 236, 225);
  border: 1px solid #000;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.el-106 {
  grid-column: 7 / 11;
  grid-row: 22 / 24;
  font-size: 10.0pt;
  font-weight: bold;
  color: #000;
  background: rgb(238, 236, 225);
  border: 1px solid #000;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.el-107 {
  grid-column: 11 / 15;
  grid-row: 22 / 24;
  font-size: 10.0pt;
  font-weight: bold;
  color: #000;
  background: rgb(238, 236, 225);
  border: 1px solid #000;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.el-108 {
  grid-column: 15 / 20;
  grid-row: 22 / 24;
  font-size: 10.0pt;
  font-weight: bold;
  color: #000;
  background: rgb(238, 236, 225);
  border: 1px solid #000;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.el-109 {
  grid-column: 20 / 25;
  grid-row: 22 / 24;
  font-size: 10.0pt;
  font-weight: bold;
  color: #000;
  background: rgb(238, 236, 225);
  border: 1px solid #000;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.el-110 {
  grid-column: 25 / 28;
  grid-row: 22 / 24;
  font-size: 10.0pt;
  font-weight: bold;
  color: #000;
  background: rgb(238, 236, 225);
  border: 1px solid #000;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.el-111 {
  grid-column: 28 / 33;
  grid-row: 22 / 24;
  font-size: 10.0pt;
  font-weight: bold;
  color: #000;
  background: rgb(238, 236, 225);
  border: 1px solid #000;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.el-112 {
  grid-column: 33 / 37;
  grid-row: 23 / 24;
  font-size: 10.0pt;
  color: #000;
  background: rgb(238, 236, 225);
  border: 1px solid #000;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.el-113 {
  grid-column: 37 / 40;
  grid-row: 23 / 24;
  font-size: 10.0pt;
  color: #000;
  background: rgb(238, 236, 225);
  border: 1px solid #000;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.el-114 {
  grid-column: 40 / 44;
  grid-row: 23 / 24;
  font-size: 10.0pt;
  color: #000;
  background: rgb(238, 236, 225);
  border: 1px solid #000;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.el-115 {
  grid-column: 44 / 47;
  grid-row: 23 / 24;
  font-size: 10.0pt;
  color: #000;
  background: rgb(238, 236, 225);
  border: 1px solid #000;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.el-116 {
  grid-column: 47 / 49;
  grid-row: 22 / 24;
  font-size: 10.0pt;
  font-weight: bold;
  color: #000;
  background: rgb(238, 236, 225);
  border: 1px solid #000;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.el-117 {
  grid-column: 33 / 47;
  grid-row: 22 / 23;
  font-size: 10.0pt;
  font-weight: bold;
  color: #000;
  background: rgb(238, 236, 225);
  border: 1px solid #000;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.el-118 {
  grid-column: 1 / 7;
  grid-row: 24 / 25;
  font-size: 10.0pt;
  color: #000;
  border: 1px solid #000;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.el-119 {
  grid-column: 1 / 7;
  grid-row: 25 / 26;
  font-size: 10.0pt;
  color: #000;
  border: 1px solid #000;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.el-120 {
  grid-column: 1 / 7;
  grid-row: 26 / 27;
  font-size: 10.0pt;
  color: #000;
  border: 1px solid #000;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.el-121 {
  grid-column: 1 / 7;
  grid-row: 27 / 28;
  font-size: 10.0pt;
  color: #000;
  border: 1px solid #000;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.el-122 {
  grid-column: 7 / 11;
  grid-row: 24 / 25;
  font-size: 10.0pt;
  color: #000;
  border: 1px solid #000;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.el-123 {
  grid-column: 7 / 11;
  grid-row: 25 / 26;
  font-size: 10.0pt;
  color: #000;
  border: 1px solid #000;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.el-124 {
  grid-column: 7 / 11;
  grid-row: 26 / 27;
  font-size: 10.0pt;
  color: #000;
  border: 1px solid #000;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.el-125 {
  grid-column: 7 / 11;
  grid-row: 27 / 28;
  font-size: 10.0pt;
  color: #000;
  border: 1px solid #000;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.el-126 {
  grid-column: 11 / 15;
  grid-row: 24 / 25;
  font-size: 10.0pt;
  color: #000;
  border: 1px solid #000;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.el-127 {
  grid-column: 11 / 15;
  grid-row: 25 / 26;
  font-size: 10.0pt;
  color: #000;
  border: 1px solid #000;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.el-128 {
  grid-column: 11 / 15;
  grid-row: 26 / 27;
  font-size: 10.0pt;
  color: #000;
  border: 1px solid #000;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.el-129 {
  grid-column: 11 / 15;
  grid-row: 27 / 28;
  font-size: 10.0pt;
  color: #000;
  border: 1px solid #000;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.el-130 {
  grid-column: 15 / 20;
  grid-row: 24 / 25;
  font-size: 10.0pt;
  color: #000;
  border: 1px solid #000;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.el-131 {
  grid-column: 15 / 20;
  grid-row: 25 / 26;
  font-size: 10.0pt;
  color: #000;
  border: 1px solid #000;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.el-132 {
  grid-column: 15 / 20;
  grid-row: 26 / 27;
  font-size: 10.0pt;
  color: #000;
  border: 1px solid #000;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.el-133 {
  grid-column: 15 / 20;
  grid-row: 27 / 28;
  font-size: 10.0pt;
  color: #000;
  border: 1px solid #000;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.el-134 {
  grid-column: 20 / 25;
  grid-row: 24 / 25;
  font-size: 10.0pt;
  color: #000;
  border: 1px solid #000;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.el-135 {
  grid-column: 20 / 25;
  grid-row: 25 / 26;
  font-size: 10.0pt;
  color: #000;
  border: 1px solid #000;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.el-136 {
  grid-column: 20 / 25;
  grid-row: 26 / 27;
  font-size: 10.0pt;
  color: #000;
  border: 1px solid #000;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.el-137 {
  grid-column: 20 / 25;
  grid-row: 27 / 28;
  font-size: 10.0pt;
  color: #000;
  border: 1px solid #000;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.el-138 {
  grid-column: 25 / 28;
  grid-row: 24 / 25;
  font-size: 10.0pt;
  color: #000;
  border: 1px solid #000;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.el-139 {
  grid-column: 25 / 28;
  grid-row: 25 / 26;
  font-size: 10.0pt;
  color: #000;
  border: 1px solid #000;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.el-140 {
  grid-column: 25 / 28;
  grid-row: 26 / 27;
  font-size: 10.0pt;
  color: #000;
  border: 1px solid #000;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.el-141 {
  grid-column: 25 / 28;
  grid-row: 27 / 28;
  font-size: 10.0pt;
  color: #000;
  border: 1px solid #000;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.el-142 {
  grid-column: 28 / 33;
  grid-row: 24 / 25;
  font-size: 10.0pt;
  color: #000;
  border: 1px solid #000;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.el-143 {
  grid-column: 28 / 33;
  grid-row: 25 / 26;
  font-size: 10.0pt;
  color: #000;
  border: 1px solid #000;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.el-144 {
  grid-column: 28 / 33;
  grid-row: 26 / 27;
  font-size: 10.0pt;
  color: #000;
  border: 1px solid #000;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.el-145 {
  grid-column: 28 / 33;
  grid-row: 27 / 28;
  font-size: 10.0pt;
  color: #000;
  border: 1px solid #000;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.el-146 {
  grid-column: 33 / 37;
  grid-row: 24 / 25;
  font-size: 10.0pt;
  color: #000;
  border: 1px solid #000;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.el-147 {
  grid-column: 33 / 37;
  grid-row: 25 / 26;
  font-size: 10.0pt;
  color: #000;
  border: 1px solid #000;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.el-148 {
  grid-column: 33 / 37;
  grid-row: 26 / 27;
  font-size: 10.0pt;
  color: #000;
  border: 1px solid #000;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.el-149 {
  grid-column: 33 / 37;
  grid-row: 27 / 28;
  font-size: 10.0pt;
  color: #000;
  border: 1px solid #000;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.el-150 {
  grid-column: 37 / 40;
  grid-row: 24 / 25;
  font-size: 10.0pt;
  color: #000;
  border: 1px solid #000;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.el-151 {
  grid-column: 37 / 40;
  grid-row: 25 / 26;
  font-size: 10.0pt;
  color: #000;
  border: 1px solid #000;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.el-152 {
  grid-column: 37 / 40;
  grid-row: 26 / 27;
  font-size: 10.0pt;
  color: #000;
  border: 1px solid #000;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.el-153 {
  grid-column: 37 / 40;
  grid-row: 27 / 28;
  font-size: 10.0pt;
  color: #000;
  border: 1px solid #000;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.el-154 {
  grid-column: 40 / 44;
  grid-row: 24 / 25;
  font-size: 10.0pt;
  color: #000;
  border: 1px solid #000;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.el-155 {
  grid-column: 40 / 44;
  grid-row: 25 / 26;
  font-size: 10.0pt;
  color: #000;
  border: 1px solid #000;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.el-156 {
  grid-column: 40 / 44;
  grid-row: 26 / 27;
  font-size: 10.0pt;
  color: #000;
  border: 1px solid #000;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.el-157 {
  grid-column: 40 / 44;
  grid-row: 27 / 28;
  font-size: 10.0pt;
  color: #000;
  border: 1px solid #000;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.el-158 {
  grid-column: 44 / 47;
  grid-row: 24 / 25;
  font-size: 10.0pt;
  color: #000;
  border: 1px solid #000;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.el-159 {
  grid-column: 44 / 47;
  grid-row: 25 / 26;
  font-size: 10.0pt;
  color: #000;
  border: 1px solid #000;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.el-160 {
  grid-column: 44 / 47;
  grid-row: 26 / 27;
  font-size: 10.0pt;
  color: #000;
  border: 1px solid #000;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.el-161 {
  grid-column: 44 / 47;
  grid-row: 27 / 28;
  font-size: 10.0pt;
  color: #000;
  border: 1px solid #000;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.el-162 {
  grid-column: 47 / 49;
  grid-row: 24 / 25;
  font-size: 10.0pt;
  color: #000;
  border: 1px solid #000;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.el-163 {
  grid-column: 47 / 49;
  grid-row: 25 / 26;
  font-size: 10.0pt;
  color: #000;
  border: 1px solid #000;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.el-164 {
  grid-column: 47 / 49;
  grid-row: 26 / 27;
  font-size: 10.0pt;
  color: #000;
  border: 1px solid #000;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.el-165 {
  grid-column: 47 / 49;
  grid-row: 27 / 28;
  font-size: 10.0pt;
  color: #000;
  border: 1px solid #000;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.el-166 {
  grid-column: 1 / 49;
  grid-row: 28 / 29;
  background: rgb(238, 236, 225);
  border: 1px solid #000;
}

.el-167 {
  grid-column: 16 / 33;
  grid-row: 28 / 29;
  font-size: 12.0pt;
  font-weight: bold;
  color: #000;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.el-168 {
  grid-column: 25 / 49;
  grid-row: 29 / 30;
  font-size: 10.0pt;
  font-weight: bold;
  color: #000;
  background: rgb(238, 236, 225);
  border: 1px solid #000;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.el-169 {
  grid-column: 1 / 25;
  grid-row: 29 / 30;
  font-size: 10.0pt;
  font-weight: bold;
  color: #000;
  background: rgb(238, 236, 225);
  border: 1px solid #000;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.el-170 {
  grid-column: 25 / 49;
  grid-row: 30 / 31;
  font-size: 10.0pt;
  color: #000;
  border: 1px solid #000;
  align-items: center;
  justify-content: center;
  text-align: right;
}

.el-168a,
.el-170a {
  grid-column: 1 / 49;
}


.el-171 {
  grid-column: 1 / 25;
  grid-row: 30 / 31;
  font-size: 10.0pt;
  color: #000;
  border: 1px solid #000;
  align-items: center;
  justify-content: center;
  text-align: right;
}

.el-172 {
  grid-column: 32 / 49;
  grid-row: 31 / 32;
  font-size: 10.0pt;
  font-weight: bold;
  color: #000;
  background: rgb(238, 236, 225);
  border: 1px solid #000;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.el-173 {
  grid-column: 10 / 32;
  grid-row: 31 / 32;
  font-size: 10.0pt;
  font-weight: bold;
  color: #000;
  background: rgb(238, 236, 225);
  border: 1px solid #000;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.el-174 {
  grid-column: 1 / 10;
  grid-row: 31 / 32;
  font-size: 10.0pt;
  font-weight: bold;
  color: #000;
  background: rgb(238, 236, 225);
  border: 1px solid #000;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.el-175 {
  grid-column: 32 / 49;
  grid-row: 32 / 33;
  font-size: 10.0pt;
  color: #000;
  border: 1px solid #000;
  align-items: center;
  justify-content: center;
  text-align: right;
}

.el-176 {
  grid-column: 10 / 32;
  grid-row: 32 / 33;
  font-size: 10.0pt;
  color: #000;
  border: 1px solid #000;
  align-items: center;
  justify-content: center;
  text-align: right;
}

.el-177 {
  grid-column: 1 / 10;
  grid-row: 32 / 33;
  font-size: 10.0pt;
  color: #000;
  border: 1px solid #000;
  align-items: center;
  justify-content: center;
  text-align: right;
}

.el-178 {
  grid-column: 22 / 49;
  grid-row: 33 / 34;
  font-size: 10.0pt;
  font-weight: bold;
  color: #000;
  background: rgb(238, 236, 225);
  border: 1px solid #000;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.el-178a {
  grid-column: 1 / 49;
}

.el-179 {
  grid-column: 45 / 49;
  grid-row: 34 / 36;
  font-size: 10.0pt;
  font-weight: bold;
  color: #000;
  background: rgb(238, 236, 225);
  border: 1px solid #000;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.el-179a {
  grid-column: 42 / 49;
}

.el-180 {
  grid-column: 38 / 45;
  grid-row: 34 / 36;
  font-size: 10.0pt;
  font-weight: bold;
  color: #000;
  background: rgb(238, 236, 225);
  border: 1px solid #000;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.el-180a {
  grid-column: 30 / 42;
}

.el-181 {
  grid-column: 28 / 38;
  grid-row: 34 / 35;
  font-size: 10.0pt;
  font-weight: bold;
  color: #000;
  background: rgb(238, 236, 225);
  border: 1px solid #000;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.el-181a {
  grid-column: 13 / 30;
}

.el-182 {
  grid-column: 33 / 38;
  grid-row: 35 / 36;
  font-size: 10.0pt;
  font-weight: bold;
  color: #000;
  background: rgb(238, 236, 225);
  border: 1px solid #000;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.el-182a {
  grid-column: 21 / 30;
}

.el-183 {
  grid-column: 28 / 33;
  grid-row: 35 / 36;
  font-size: 10.0pt;
  font-weight: bold;
  color: #000;
  background: rgb(238, 236, 225);
  border: 1px solid #000;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.el-183a {
  grid-column: 13 / 21;
}

.el-184 {
  grid-column: 22 / 28;
  grid-row: 34 / 35;
  font-size: 10.0pt;
  font-weight: bold;
  color: #000;
  background: rgb(238, 236, 225);
  border: 1px solid #000;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.el-184a {
  grid-column: 1 / 13;
}

.el-185 {
  grid-column: 45 / 49;
  grid-row: 36 / 37;
  font-size: 10.0pt;
  color: #000;
  border: 1px solid #000;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.el-185a {
  grid-column: 42 / 49;
}

.el-186 {
  grid-column: 38 / 45;
  grid-row: 36 / 37;
  font-size: 10.0pt;
  color: #000;
  border: 1px solid #000;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.el-186a {
  grid-column: 30 / 42;
}

.el-187 {
  grid-column: 33 / 38;
  grid-row: 36 / 37;
  font-size: 7.5pt;
  color: #000;
  border: 1px solid #000;
  align-items: center;
  justify-content: center;
  text-align: center;
  line-height: 12px;
}

.el-187a {
  grid-column: 21 / 30;
}

.el-188 {
  grid-column: 28 / 33;
  grid-row: 36 / 37;
  font-size: 7.5pt;
  color: #000;
  border: 1px solid #000;
  align-items: center;
  justify-content: center;
  text-align: center;
  line-height: 12px;
}

.el-188a {
  grid-column: 13 / 21;
}

.el-189 {
  grid-column: 26 / 28;
  grid-row: 36 / 37;
  font-size: 10.0pt;
  color: #000;
  border: 1px solid #000;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.el-189a {
  grid-column: 4 / 13;
}

.el-190 {
  grid-column: 43 / 49;
  grid-row: 37 / 39;
  font-size: 10.0pt;
  font-weight: bold;
  color: #000;
  background: rgb(238, 236, 225);
  border: 1px solid #000;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.el-190a {
  grid-column: 39 / 49;
}

.el-191 {
  grid-column: 30 / 43;
  grid-row: 37 / 38;
  font-size: 10.0pt;
  font-weight: bold;
  color: #000;
  background: rgb(238, 236, 225);
  border: 1px solid #000;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.el-191a {
  grid-column: 17 / 39;
}

.el-191b {
  grid-column: 32 / 43;
}

.el-192 {
  grid-column: 37 / 43;
  grid-row: 38 / 39;
  font-size: 10.0pt;
  font-weight: bold;
  color: #000;
  background: rgb(238, 236, 225);
  border: 1px solid #000;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.el-192a {
  grid-column: 17 / 28;
}

.el-192b {
  grid-column: 32 / 38;
}

.el-193 {
  grid-column: 30 / 37;
  grid-row: 38 / 39;
  font-size: 10.0pt;
  font-weight: bold;
  color: #000;
  background: rgb(238, 236, 225);
  border: 1px solid #000;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.el-193a {
  grid-column: 38 / 43;
}

.el-193b {
  grid-column: 28 / 39;
}

.el-194 {
  grid-column: 22 / 30;
  grid-row: 37 / 39;
  font-size: 10.0pt;
  font-weight: bold;
  color: #000;
  background: rgb(238, 236, 225);
  border: 1px solid #000;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.el-194a {
  grid-column: 1 / 17;
}

.el-195 {
  grid-column: 43 / 49;
  grid-row: 39 / 40;
  font-size: 10.0pt;
  color: #000;
  border: 1px solid #000;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.el-195a {
  grid-column: 39 / 49;
}

.el-196 {
  grid-column: 37 / 43;
  grid-row: 39 / 40;
  font-size: 7.5pt;
  color: #000;
  border: 1px solid #000;
  align-items: center;
  justify-content: center;
  text-align: center;
  line-height: 12px;
}

.el-196a {
  grid-column: 32 / 38;
}

.el-196b {
  grid-column: 28 / 39;
}

.el-197 {
  grid-column: 30 / 37;
  grid-row: 39 / 40;
  font-size: 7.5pt;
  color: #000;
  border: 1px solid #000;
  align-items: center;
  justify-content: center;
  text-align: center;
  line-height: 12px;
}

.el-197a {
  grid-column: 17 / 28;
}

.el-197b {
  grid-column: 38 / 43;
}

.el-198 {
  grid-column: 22 / 30;
  grid-row: 39 / 40;
  font-size: 7.5pt;
  color: #000;
  border: 1px solid #000;
  align-items: center;
  justify-content: center;
  text-align: center;
  line-height: 12px;
}

.el-198a {
  grid-column: 1 / 17;
}

.el-199 {
  grid-column: 1 / 22;
  grid-row: 33 / 34;
  font-size: 10.0pt;
  font-weight: bold;
  color: #000;
  background: rgb(238, 236, 225);
  border: 1px solid #000;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.el-200 {
  grid-column: 8 / 22;
  grid-row: 34 / 35;
  font-size: 10.0pt;
  font-weight: bold;
  color: #000;
  background: rgb(238, 236, 225);
  border: 1px solid #000;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.el-201 {
  grid-column: 1 / 8;
  grid-row: 34 / 35;
  font-size: 10.0pt;
  font-weight: bold;
  color: #000;
  background: rgb(238, 236, 225);
  border: 1px solid #000;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.el-202 {
  grid-column: 8 / 22;
  grid-row: 35 / 40;
  font-size: 10.0pt;
  color: #000;
  border: 1px solid #000;
  align-items: center;
  justify-content: center;
  text-align: right;
}

.el-203 {
  grid-column: 1 / 8;
  grid-row: 35 / 40;
  font-size: 10.0pt;
  color: #000;
  border: 1px solid #000;
  align-items: center;
  justify-content: center;
  text-align: right;
}

.el-204 {
  grid-column: 45 / 49;
  grid-row: 40 / 41;
  font-size: 10.0pt;
  font-weight: bold;
  color: #000;
  background: rgb(238, 236, 225);
  border: 1px solid #000;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.el-205 {
  grid-column: 1 / 45;
  grid-row: 40 / 41;
  font-size: 10.0pt;
  color: #000;
  border: 1px solid #000;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.el-206 {
  grid-column: 42 / 49;
  grid-row: 41 / 42;
  font-size: 10.0pt;
  font-weight: bold;
  color: #000;
  background: rgb(238, 236, 225);
  border: 1px solid #000;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.el-207 {
  grid-column: 47 / 49;
  grid-row: 42 / 43;
  font-size: 10.0pt;
  font-weight: bold;
  color: #000;
  background: rgb(238, 236, 225);
  border: 1px solid #000;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.el-208 {
  grid-column: 42 / 47;
  grid-row: 42 / 43;
  font-size: 10.0pt;
  font-weight: bold;
  color: #000;
  background: rgb(238, 236, 225);
  border: 1px solid #000;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.el-209 {
  grid-column: 30 / 42;
  grid-row: 41 / 42;
  font-size: 10.0pt;
  font-weight: bold;
  color: #000;
  background: rgb(238, 236, 225);
  border: 1px solid #000;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.el-210 {
  grid-column: 36 / 42;
  grid-row: 42 / 43;
  font-size: 10.0pt;
  font-weight: bold;
  color: #000;
  background: rgb(238, 236, 225);
  border: 1px solid #000;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.el-211 {
  grid-column: 30 / 36;
  grid-row: 42 / 43;
  font-size: 10.0pt;
  font-weight: bold;
  color: #000;
  background: rgb(238, 236, 225);
  border: 1px solid #000;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.el-212 {
  grid-column: 18 / 30;
  grid-row: 41 / 42;
  font-size: 10.0pt;
  font-weight: bold;
  color: #000;
  background: rgb(238, 236, 225);
  border: 1px solid #000;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.el-213 {
  grid-column: 25 / 30;
  grid-row: 42 / 43;
  font-size: 10.0pt;
  font-weight: bold;
  color: #000;
  background: rgb(238, 236, 225);
  border: 1px solid #000;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.el-214 {
  grid-column: 18 / 25;
  grid-row: 42 / 43;
  font-size: 10.0pt;
  font-weight: bold;
  color: #000;
  background: rgb(238, 236, 225);
  border: 1px solid #000;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.el-215 {
  grid-column: 5 / 18;
  grid-row: 41 / 42;
  font-size: 10.0pt;
  font-weight: bold;
  color: #000;
  background: rgb(238, 236, 225);
  border: 1px solid #000;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.el-216 {
  grid-column: 12 / 18;
  grid-row: 42 / 43;
  font-size: 10.0pt;
  font-weight: bold;
  color: #000;
  background: rgb(238, 236, 225);
  border: 1px solid #000;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.el-217 {
  grid-column: 5 / 12;
  grid-row: 42 / 43;
  font-size: 10.0pt;
  font-weight: bold;
  color: #000;
  background: rgb(238, 236, 225);
  border: 1px solid #000;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.el-218 {
  grid-column: 1 / 5;
  grid-row: 41 / 42;
  font-size: 10.0pt;
  font-weight: bold;
  color: #000;
  background: rgb(238, 236, 225);
  border: 1px solid #000;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.el-219 {
  grid-column: 2 / 5;
  grid-row: 42 / 43;
  font-size: 10.0pt;
  font-weight: bold;
  color: #000;
  background: rgb(238, 236, 225);
  border: 1px solid #000;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.el-220 {
  grid-column: 1 / 2;
  grid-row: 42 / 43;
  font-size: 10.0pt;
  font-weight: bold;
  color: #000;
  background: rgb(238, 236, 225);
  border: 1px solid #000;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.el-221 {
  grid-column: 47 / 49;
  grid-row: 43 / 44;
  font-size: 10.0pt;
  color: #000;
  border: 1px solid #000;
  align-items: center;
  justify-content: center;
  text-align: right;
}

.el-222 {
  grid-column: 42 / 47;
  grid-row: 43 / 44;
  font-size: 10.0pt;
  color: #000;
  border: 1px solid #000;
  align-items: center;
  justify-content: center;
  text-align: right;
}

.el-223 {
  grid-column: 36 / 42;
  grid-row: 43 / 44;
  font-size: 10.0pt;
  color: #000;
  border: 1px solid #000;
  align-items: center;
  justify-content: center;
  text-align: right;
}

.el-224 {
  grid-column: 30 / 36;
  grid-row: 43 / 44;
  font-size: 10.0pt;
  color: #000;
  border: 1px solid #000;
  align-items: center;
  justify-content: center;
  text-align: right;
}

.el-225 {
  grid-column: 25 / 30;
  grid-row: 43 / 44;
  font-size: 10.0pt;
  color: #000;
  border: 1px solid #000;
  align-items: center;
  justify-content: center;
  text-align: right;
}

.el-226 {
  grid-column: 18 / 25;
  grid-row: 43 / 44;
  font-size: 10.0pt;
  color: #000;
  border: 1px solid #000;
  align-items: center;
  justify-content: center;
  text-align: right;
}

.el-227 {
  grid-column: 12 / 18;
  grid-row: 43 / 44;
  font-size: 10.0pt;
  color: #000;
  border: 1px solid #000;
  align-items: center;
  justify-content: center;
  text-align: right;
}

.el-228 {
  grid-column: 5 / 12;
  grid-row: 43 / 44;
  font-size: 10.0pt;
  color: #000;
  border: 1px solid #000;
  align-items: center;
  justify-content: center;
  text-align: right;
}

.el-229 {
  grid-column: 2 / 5;
  grid-row: 43 / 44;
  font-size: 10.0pt;
  color: #000;
  border: 1px solid #000;
  align-items: center;
  justify-content: center;
  text-align: right;
}

.el-230 {
  grid-column: 1 / 2;
  grid-row: 43 / 44;
  font-size: 10.0pt;
  color: #000;
  border: 1px solid #000;
  align-items: center;
  justify-content: center;
  text-align: right;
}

.el-231 {
  grid-column: 37 / 49;
  grid-row: 44 / 45;
  font-size: 10.0pt;
  font-weight: bold;
  color: #000;
  background: rgb(238, 236, 225);
  border: 1px solid #000;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.el-232 {
  grid-column: 25 / 37;
  grid-row: 44 / 45;
  font-size: 10.0pt;
  font-weight: bold;
  color: #000;
  background: rgb(238, 236, 225);
  border: 1px solid #000;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.el-233 {
  grid-column: 10 / 25;
  grid-row: 44 / 45;
  font-size: 10.0pt;
  font-weight: bold;
  color: #000;
  background: rgb(238, 236, 225);
  border: 1px solid #000;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.el-234 {
  grid-column: 1 / 10;
  grid-row: 44 / 45;
  font-size: 10.0pt;
  font-weight: bold;
  color: #000;
  background: rgb(238, 236, 225);
  border: 1px solid #000;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.el-235 {
  grid-column: 1 / 10;
  grid-row: 45 / 52;
  font-size: 10.0pt;
  color: #000;
  border: 1px solid #000;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.el-236 {
  grid-column: 1 / 10;
  grid-row: 47 / 48;
  font-size: 10.0pt;
  font-weight: bold;
  color: #000;
  background: rgb(238, 236, 225);
  border: 1px solid #000;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.el-237 {
  grid-column: 1 / 10;
  grid-row: 48 / 50;
  font-size: 10.0pt;
  color: #000;
  border: 1px solid #000;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.el-238 {
  grid-column: 1 / 10;
  grid-row: 50 / 51;
  font-size: 10.0pt;
  font-weight: bold;
  color: #000;
  background: rgb(238, 236, 225);
  border: 1px solid #000;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.el-239 {
  grid-column: 1 / 10;
  grid-row: 51 / 52;
  font-size: 10.0pt;
  color: #000;
  border: 1px solid #000;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.el-240 {
  grid-column: 37 / 49;
  grid-row: 45 / 52;
  font-size: 10.0pt;
  color: #000;
  border: 1px solid #000;
  align-items: center;
  justify-content: center;
  text-align: right;
}

.el-241 {
  grid-column: 25 / 37;
  grid-row: 45 / 52;
  font-size: 10.0pt;
  color: #000;
  border: 1px solid #000;
  align-items: center;
  justify-content: center;
  text-align: right;
}

.el-242 {
  grid-column: 10 / 25;
  grid-row: 45 / 52;
  font-size: 10.0pt;
  color: #000;
  border: 1px solid #000;
  align-items: center;
  justify-content: center;
  text-align: right;
}

.el-243 {
  grid-column: 1 / 10;
  grid-row: 50 / 51;
  font-size: 10.0pt;
  font-weight: bold;
  color: #000;
  background: rgb(238, 236, 225);
  border: 1px solid #000;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.el-244 {
  grid-column: 1 / 10;
  grid-row: 51 / 52;
  font-size: 10.0pt;
  color: #000;
  border: 1px solid #000;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.el-245 {
  grid-column: 39 / 44;
  grid-row: 12 / 13;
  font-size: 10.0pt;
  color: #000;
  border: 1px solid #000;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.el-246 {
  grid-column: 44 / 49;
  grid-row: 12 / 13;
  font-size: 10.0pt;
  font-weight: bold;
  color: #000;
  background: rgb(238, 236, 225);
  border: 1px solid #000;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.el-247 {
  grid-column: 25 / 29;
  grid-row: 12 / 13;
  font-size: 10.0pt;
  color: #000;
  border: 1px solid #000;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.el-248 {
  grid-column: 29 / 39;
  grid-row: 12 / 13;
  font-size: 10.0pt;
  font-weight: bold;
  color: #000;
  background: rgb(238, 236, 225);
  border: 1px solid #000;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.el-249 {
  grid-column: 10 / 16;
  grid-row: 12 / 13;
  font-size: 10.0pt;
  color: #000;
  border: 1px solid #000;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.el-250 {
  grid-column: 16 / 25;
  grid-row: 12 / 13;
  font-size: 10.0pt;
  font-weight: bold;
  color: #000;
  background: rgb(238, 236, 225);
  border: 1px solid #000;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.el-251 {
  grid-column: 26 / 28;
  grid-row: 35 / 36;
  font-size: 10.0pt;
  font-weight: bold;
  color: #000;
  background: rgb(238, 236, 225);
  border: 1px solid #000;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.el-251a {
  grid-column: 4 / 13;
}

.el-252 {
  grid-column: 22 / 26;
  grid-row: 35 / 36;
  font-size: 10.0pt;
  font-weight: bold;
  color: #000;
  background: rgb(238, 236, 225);
  border: 1px solid #000;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.el-252a {
  grid-column: 1 / 4;
}

.el-253 {
  grid-column: 22 / 26;
  grid-row: 36 / 37;
  font-size: 10.0pt;
  color: #000;
  border: 1px solid #000;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.el-253a {
  grid-column: 1 / 4;
}

.el-254 {
  /* grid-column: 1 / 49;
  grid-row: 20 / 21; */
  grid-column: 1 / 34;
  grid-row: 9 / 11;
  font-size: 10.0pt;
  color: #000;
  border: 1px solid #000;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.el-255 {
  grid-column: 3 / 25;
  grid-row: 30 / 31;
  font-size: 7.5pt;
  color: #000;
  border: 1px solid #000;
  align-items: center;
  justify-content: center;
  text-align: right;
}

.el-256 {
  grid-column: 1 / 3;
  grid-row: 29 / 30;
  font-size: 10.0pt;
  font-weight: bold;
  color: #000;
  background: rgb(238, 236, 225);
  border: 1px solid #000;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.el-257 {
  grid-column: 1 / 3;
  grid-row: 30 / 31;
  font-size: 10.0pt;
  color: #000;
  border: 1px solid #000;
  align-items: center;
  justify-content: center;
  text-align: right;
}

.el-258 {
  grid-column: 22 / 32;
  grid-row: 37 / 38;
  font-size: 10.0pt;
  font-weight: bold;
  color: #000;
  background: rgb(238, 236, 225);
  border: 1px solid #000;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.el-258a {
  grid-column: 1 / 22;
}

.el-259 {
  grid-column: 27 / 32;
  grid-row: 38 / 39;
  font-size: 10.0pt;
  font-weight: bold;
  color: #000;
  background: rgb(238, 236, 225);
  border: 1px solid #000;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.el-259a {
  grid-column: 10 / 22;
}

.el-260 {
  grid-column: 22 / 27;
  grid-row: 38 / 39;
  font-size: 10.0pt;
  font-weight: bold;
  color: #000;
  background: rgb(238, 236, 225);
  border: 1px solid #000;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.el-260a {
  grid-column: 1 / 10;
}

.el-261 {
  grid-column: 27 / 32;
  grid-row: 39 / 40;
  font-size: 8.0pt;
  color: #000;
  border: 1px solid #000;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.el-261a {
  grid-column: 10 / 22;
}

.el-262 {
  grid-column: 22 / 27;
  grid-row: 39 / 40;
  font-size: 8.0pt;
  color: #000;
  border: 1px solid #000;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.el-262a {
  grid-column: 1 / 10;
}

.el-263 {
  grid-column: 1 / 22;
  grid-row: 34 / 40;
  font-size: 10.0pt;
  color: #000;
  border: 1px solid #000;
  align-items: center;
  justify-content: center;
  text-align: right;
}

.el-264 {
  grid-column: 25 / 49;
  grid-row: 41 / 42;
  font-size: 10.0pt;
  font-weight: bold;
  color: #000;
  background: rgb(238, 236, 225);
  border: 1px solid #000;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.el-265 {
  grid-column: 25 / 49;
  grid-row: 42 / 44;
  font-size: 10.0pt;
  color: #000;
  border: 1px solid #000;
  align-items: center;
  justify-content: center;
  text-align: right;
}

.el-266 {
  grid-column: 1 / 25;
  grid-row: 41 / 42;
  font-size: 10.0pt;
  font-weight: bold;
  color: #000;
  background: rgb(238, 236, 225);
  border: 1px solid #000;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.el-267 {
  grid-column: 1 / 25;
  grid-row: 42 / 44;
  font-size: 10.0pt;
  color: #000;
  border: 1px solid #000;
  align-items: center;
  justify-content: center;
  text-align: right;
}

.el-269 {
  grid-column: 3 / 25;
  grid-row: 29 / 30;
  font-size: 10.0pt;
  font-weight: bold;
  color: #000;
  background: rgb(238, 236, 225);
  border: 1px solid #000;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.btnClick-14 {
  grid-column: 1 / 49;
  grid-row: 6 / 19;
}

.btnClick-104 {
  grid-column: 1 / 49;
  grid-row: 21 / 28;
}

.btnClick-168 {
  grid-column: 25 / 49;
  grid-row: 29 / 31;
}

.btnClick-168a {
  grid-column: 1 / 49;
}

.btnClick-169 {
  grid-column: 1 / 25;
  grid-row: 29 / 31;
}

.btnClick-172 {
  grid-column: 32 / 49;
  grid-row: 31 / 33;
}

.btnClick-173 {
  grid-column: 10 / 32;
  grid-row: 31 / 33;
}

.btnClick-174 {
  grid-column: 1 / 10;
  grid-row: 31 / 33;
}

.btnClick-178 {
  grid-column: 22 / 49;
  grid-row: 33 / 40;
}

.el-btnClick-178a {
  grid-column: 1 / 49;
}

.btnClick-199 {
  grid-column: 1 / 22;
  grid-row: 33 / 40;
}

.btnClick-199a {
  grid-column: 1 / 22;
  grid-row: 33 / 39;
}

.btnClick-231 {
  grid-column: 37 / 49;
  grid-row: 44 / 52;

}

.btnClick-232 {
  grid-column: 25 / 37;
  grid-row: 44 / 52;

}

.btnClick-233 {
  grid-column: 1 / 25;
  grid-row: 44 / 52;

}


.btnClick-268 {
  grid-column: 1 / 49;
  grid-row: 41 / 44;

}

.btnClick-14,
.btnClick-104,
.btnClick-168,
.btnClick-169,
.btnClick-172,
.btnClick-173,
.btnClick-174,
.btnClick-178,
.btnClick-199,
.btnClick-199a,
.btnClick-231,
.btnClick-232,
.btnClick-233,
.btnClick-268 {
  cursor: pointer;
  transition: all 0.3s ease-in-out;
  z-index: 1;
}

.btnClick-14:hover,
.btnClick-104:hover,
.btnClick-168:hover,
.btnClick-169:hover,
.btnClick-172:hover,
.btnClick-173:hover,
.btnClick-174:hover,
.btnClick-178:hover,
.btnClick-199:hover,
.btnClick-199a:hover,
.btnClick-231:hover,
.btnClick-232:hover,
.btnClick-233:hover,
.btnClick-268:hover {
  background: #f1ff002b;
  border: 1px solid black;
}



@media print {
  .rp-page {
    box-shadow: none;
    margin: 0;
  }

  @page {
    size: A4;
    margin: 0;
  }
}
</style>
